import { render } from "./Homeworks.vue?vue&type=template&id=7c36ad18&scoped=true"
import script from "./Homeworks.vue?vue&type=script&lang=js"
export * from "./Homeworks.vue?vue&type=script&lang=js"

import "./Homeworks.vue?vue&type=style&index=0&id=7c36ad18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c36ad18"]])

export default __exports__